import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { segmentApi } from '@edulastic/api'
import {
  saveAllItemStandardsAction,
  resetBulkStandardsStateAction,
} from '../ducks/bulkQuestionMetadata'
import { getTestEntitySelector } from '../../TestPage/ducks'
import {
  StyledPendingMetadataModal,
  StyledPendingMetadataModalHeader,
  StyledPendingMetadataModalTitle,
  StyledPendingMetadataModalClose,
  StyledPendingMetadataModalDivider,
  StyledPendingMetadataModalBody,
  StyledPendingMetadataModalBodyText,
  StyledPendingMetadataModalFooter,
  StyledPendingMetadataModalRejectButton,
  StyledPendingMetadataModalAcceptButton,
} from './styled'

const PendingMetadataSuggestionsModal = ({
  visible,
  test,
  saveAllItemStandards,
  resetSuggestions,
  onClose,
}) => {
  const { _id: testId } = test || {}

  const trackConfirmationAction = (action) => {
    segmentApi.genericEventTrack(
      'AITestQuestionsMetadata:PendingConfirmationAction',
      { action, testId },
      { attachUserData: true }
    )
  }

  const handleAcceptAll = () => {
    trackConfirmationAction('accept_all')
    saveAllItemStandards()
    onClose()
  }

  const handleRejectAll = () => {
    trackConfirmationAction('reject_all')
    resetSuggestions()
    onClose()
  }

  return (
    <StyledPendingMetadataModal
      visible={visible}
      footer={null}
      closable={false}
      centered
      width={440}
      onCancel={onClose}
      destroyOnClose
    >
      <StyledPendingMetadataModalHeader>
        <StyledPendingMetadataModalTitle data-cy="pendingSuggestionsHeading">
          Unsaved metadata suggestions
        </StyledPendingMetadataModalTitle>
        <StyledPendingMetadataModalClose
          type="close"
          data-cy="pendingSuggestionsClose"
          onClick={onClose}
        />
      </StyledPendingMetadataModalHeader>
      <StyledPendingMetadataModalDivider />
      <StyledPendingMetadataModalBody>
        <StyledPendingMetadataModalBodyText data-cy="pendingSuggestionsMessage">
          Pear uses AI to generate metadata. Please review standards, DoK, and
          difficulty for accuracy before use.
        </StyledPendingMetadataModalBodyText>
      </StyledPendingMetadataModalBody>
      <StyledPendingMetadataModalFooter>
        <StyledPendingMetadataModalRejectButton
          type="button"
          data-cy="pendingSuggestionsRejectAll"
          onClick={handleRejectAll}
        >
          Reject All
        </StyledPendingMetadataModalRejectButton>
        <StyledPendingMetadataModalAcceptButton
          type="button"
          data-cy="pendingSuggestionsAcceptAll"
          onClick={handleAcceptAll}
        >
          Accept All Suggestions
        </StyledPendingMetadataModalAcceptButton>
      </StyledPendingMetadataModalFooter>
    </StyledPendingMetadataModal>
  )
}

PendingMetadataSuggestionsModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  test: PropTypes.object,
  saveAllItemStandards: PropTypes.func.isRequired,
  resetSuggestions: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

PendingMetadataSuggestionsModal.defaultProps = {
  test: {},
}

export default connect(
  (state) => ({
    test: getTestEntitySelector(state),
  }),
  {
    saveAllItemStandards: saveAllItemStandardsAction,
    resetSuggestions: resetBulkStandardsStateAction,
  }
)(PendingMetadataSuggestionsModal)
